export default function favoritType(app) {
	app.constant("FAVORIT_TYPE", {
		PARTNER: "ebiz_partner",
		INVOICE: "invoice",
		TRANSFER: "ebiz_transfer"
	});
}
